import React, {useState, useRef, useEffect} from "react";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  AppBar,
  Typography,
  Toolbar,
  TextField,
  Grid,
  Dialog,
  Slide,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {makeStyles} from "@material-ui/core/styles";
import {Close, Save, Check} from "@material-ui/icons";
import {getCookie} from "../../../../../components/auth/Helpers";
import axios from "axios";
import AddOperationForm from "../../AddOperationForm";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    minWidth: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateSnForm = (props) => {
  console.log(props.cabinetsList);
  const token = getCookie("token");
  const classes = useStyles(); //custom css
  const [formValues, setFormValues] = useState({cabinet: {}, operations: props.operations});
  const [operationNumberValue, setOperationNumberValue] = useState([]);

  const handleChangeSn = (e, newValue) => {
    if (newValue) setFormValues({...formValues, cabinet: newValue});
  };

  useEffect(() => {
    setOperationNumberValue(props.dataToUpdate);
  }, []);

  const handleSaveForm = async () => {
    console.log("formValues", {operations: formValues.operations, sn: formValues.cabinet._id});
    const data = {operations: formValues.operations, sn: formValues.cabinet._id};
    await axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/liveOperations/updateSn`,
      headers: {Authorization: `Bearer ${token}`},
      data: data,
    })
      .then((response) => {
        props.setOpenUpdateSnForm(false);
        props.setUpdateData((prev) => prev + 1);
      })
      .catch((error) => {});
  };
  return (
    <>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Close onClick={() => props.setOpenUpdateSnForm(false)} className="btnIcon" />
          <Typography variant="h6" className={classes.title}>
            Update Sn
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid container spacing={3} justify="center" alignContent="center">
        <Grid item xs={11}>
          <Autocomplete
            multiple
            freeSolo
            fullWidth
            id="operationNumberInput"
            value={operationNumberValue || {}}
            options={[]}
            getOptionLabel={(option) => option}
            // onChange={handleChangeSn}
            renderInput={(params) => <TextField {...params} label="operationNumber" />}
          />
        </Grid>
        <Grid item xs={11}>
          <FormControl className={classes.formControl}>
            <Autocomplete
              id="cabinet"
              options={props.cabinetsList || {}}
              value={formValues.cabinet || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.sn : "";
              }}
              fullWidth
              onChange={handleChangeSn}
              renderInput={(params) => <TextField {...params} label="New Cabinet" />}
            />
          </FormControl>
        </Grid>

        <Grid item xs={11} className="clientTables">
          <Button
            variant="contained"
            color="primary"
            size="large"
            className="btn btn--save"
            onClick={handleSaveForm}
            startIcon={<Save />}
          >
            {"Update"}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            className="btn btn--save"
            onClick={() => props.setOpenUpdateSnForm(false)}
            startIcon={<Close />}
          >
            Close
          </Button>
        </Grid>
      </Grid>

      {/* <div>
        <Dialog
          maxWidth={"md"}
          fullWidth
          TransitionComponent={Transition}
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
        >
          <div style={{minHeight: "80vh", overflowX: "hidden"}}>
            <AddOperationForm
              type={"Corrective Maintenance"}
              fridge={fridge}
              operations={props.operations}
              setOpenDialog={setOpenAddDialog}
              jobNumber={jobNumber}
              setItemsUpdated={setItemsUpdated}
              setPricesToUse={setPricesToUse}
            />
          </div>
        </Dialog>
      </div> */}
    </>
  );
};
export default UpdateSnForm;
